/** @file nodeKeyOf: a node's key at a frame, or the latest earlier key naming it (shown muted). */
import type { Clip, NodeKey } from '@zilo/pose3d-format/types/clip';

/** The key found, the frame it sits on and whether that frame is the asked one. */
export type NodeKeyView = { key: NodeKey; frame: number; exact: boolean };

/**
 * The node's key at `frame` when that key names it (and carries `field`, when given); else the latest earlier key
 * that does (`exact: false`, the inspector shows it muted with "from frame n"); null when no such key exists.
 */
export function nodeKeyOf(clip: Pick<Clip, 'keys'>, frame: number, node: string, field?: keyof NodeKey): NodeKeyView | null {
  let found: NodeKeyView | null = null;
  for (const k of clip.keys) {
    if (k.frame > frame) break;
    const nk = k.nodes[node];
    if (nk !== undefined && (field === undefined || nk[field] !== undefined)) found = { key: nk, frame: k.frame, exact: k.frame === frame };
  }
  return found;
}
